import {post} from '../request';

/**
 * 充值套餐
 */
/**
 * 列表
 * @param data
 * @returns {*}
 */
export function getLists(data) {
    return post("admin/Rechargepackage/index", data)
}

/**
 * 添加
 * @param data
 * @returns {*}
 */
export function setadd(data) {
    return post("admin/Rechargepackage/add", data)
}

/**
 * 编辑
 * @param data
 * @returns {*}
 */
export function setedit(data) {
    return post("admin/Rechargepackage/edit", data)
}

/**
 * 删除
 * @param data
 * @returns {*}
 */
export function setdelete(data) {
    return post("admin/Rechargepackage/delete", data)
}



